import I18n from 'I18n';
import { isTemporarySlug } from 'ContentEditorUI/utils/contentModelURLUtils';
import { POST_DEEP_LINK_QUERIES } from 'ContentEditorUI/data/postSettingsDeepLinkQueries';
import { BLOG_TITLE_PLACEHOLDER_TEXT } from './settingsConstants';
const postSettingsErrors = (contentModel, customizeTitleEnabled, hasCurrentLanguageInCurrentTranslatedContent, invalidMlangTags, invalidAuthorLanguage) => {
  const errors = {};
  if (!contentModel.get('metaDescription')) {
    errors.metaDescription = {
      pane: 'settings',
      type: 'required',
      fieldSchema: {
        title: I18n.text('components.header.validationErrorPopover.postSettingsErrors.metaDescription')
      },
      settingsModalQuery: POST_DEEP_LINK_QUERIES.METADATA.META_DESCRIPTION
    };
  }
  if (!contentModel.get('name') || contentModel.get('name') === BLOG_TITLE_PLACEHOLDER_TEXT) {
    errors.name = {
      pane: 'settings',
      type: 'required',
      fieldSchema: {
        title: I18n.text('components.header.validationErrorPopover.postSettingsErrors.name')
      },
      settingsModalQuery: POST_DEEP_LINK_QUERIES.GENERAL.NAME
    };
  }
  if (customizeTitleEnabled && (!contentModel.get('htmlTitle') || contentModel.get('htmlTitle') === BLOG_TITLE_PLACEHOLDER_TEXT)) {
    errors.htmlTitle = {
      pane: 'settings',
      type: 'required',
      fieldSchema: {
        title: I18n.text('components.header.validationErrorPopover.postSettingsErrors.htmlTitle')
      },
      settingsModalQuery: POST_DEEP_LINK_QUERIES.GENERAL.TITLE
    };
  }
  if (!contentModel.get('blogAuthorId')) {
    errors.blogAuthorId = {
      pane: 'settings',
      type: 'required'
    };
  }
  if (!contentModel.get('slug') || isTemporarySlug(contentModel.get('slug'))) {
    errors.slug = {
      pane: 'settings',
      type: 'required',
      fieldSchema: {
        title: I18n.text('components.header.validationErrorPopover.postSettingsErrors.slug')
      },
      settingsModalQuery: POST_DEEP_LINK_QUERIES.GENERAL.SLUG
    };
  }
  if (contentModel.get('useFeaturedImage') && !contentModel.get('featuredImage')) {
    errors.featuredImage = {
      pane: 'settings',
      type: 'required',
      fieldSchema: {
        title: I18n.text('components.header.validationErrorPopover.postSettingsErrors.featuredImage')
      },
      settingsModalQuery: POST_DEEP_LINK_QUERIES.IMAGE.FEATURED_IMAGE
    };
  }
  if (contentModel.get('language') && hasCurrentLanguageInCurrentTranslatedContent) {
    errors.language = {
      pane: 'settings',
      type: 'language',
      target: 'language',
      settingsModalQuery: POST_DEEP_LINK_QUERIES.LANG_AND_REGION.LANGUAGE
    };
  }
  if (Object.keys(invalidMlangTags).length > 0) {
    errors.tags = {
      pane: 'settings',
      type: 'tags',
      target: 'tags',
      messageKey: 'components.header.validationErrorPopover.postSettingsErrors.tags',
      settingsModalQuery: POST_DEEP_LINK_QUERIES.GENERAL.TAGS
    };
  }
  if (invalidAuthorLanguage) {
    errors.author = {
      pane: 'settings',
      type: 'blogAuthorId',
      target: 'blogAuthorId',
      messageKey: 'components.header.validationErrorPopover.postSettingsErrors.author',
      settingsModalQuery: POST_DEEP_LINK_QUERIES.GENERAL.AUTHOR
    };
  }
  return errors;
};
export const immerPostSettingsErrors = (contentModel, customizeTitleEnabled, hasCurrentLanguageInCurrentTranslatedContent, invalidMlangTags, invalidAuthorLanguage) => {
  const errors = {};
  if (!contentModel.metaDescription) {
    errors.metaDescription = {
      pane: 'settings',
      type: 'required',
      fieldSchema: {
        title: I18n.text('components.header.validationErrorPopover.postSettingsErrors.metaDescription')
      },
      settingsModalQuery: POST_DEEP_LINK_QUERIES.METADATA.META_DESCRIPTION
    };
  }
  if (!contentModel.name || contentModel.name === BLOG_TITLE_PLACEHOLDER_TEXT) {
    errors.name = {
      pane: 'settings',
      type: 'required',
      fieldSchema: {
        title: I18n.text('components.header.validationErrorPopover.postSettingsErrors.name')
      },
      settingsModalQuery: POST_DEEP_LINK_QUERIES.GENERAL.NAME
    };
  }
  if (customizeTitleEnabled && (!contentModel.htmlTitle || contentModel.htmlTitle === BLOG_TITLE_PLACEHOLDER_TEXT)) {
    errors.htmlTitle = {
      pane: 'settings',
      type: 'required',
      fieldSchema: {
        title: I18n.text('components.header.validationErrorPopover.postSettingsErrors.htmlTitle')
      },
      settingsModalQuery: POST_DEEP_LINK_QUERIES.GENERAL.TITLE
    };
  }
  if (!contentModel.blogAuthorId) {
    errors.blogAuthorId = {
      pane: 'settings',
      type: 'required'
    };
  }
  if (!contentModel.slug || isTemporarySlug(contentModel.slug)) {
    errors.slug = {
      pane: 'settings',
      type: 'required',
      fieldSchema: {
        title: I18n.text('components.header.validationErrorPopover.postSettingsErrors.slug')
      },
      settingsModalQuery: POST_DEEP_LINK_QUERIES.GENERAL.SLUG
    };
  }
  if (contentModel.useFeaturedImage && !contentModel.featuredImage) {
    errors.featuredImage = {
      pane: 'settings',
      type: 'required',
      fieldSchema: {
        title: I18n.text('components.header.validationErrorPopover.postSettingsErrors.featuredImage')
      },
      settingsModalQuery: POST_DEEP_LINK_QUERIES.IMAGE.FEATURED_IMAGE
    };
  }
  if (contentModel.language && hasCurrentLanguageInCurrentTranslatedContent) {
    errors.language = {
      pane: 'settings',
      type: 'language',
      target: 'language',
      settingsModalQuery: POST_DEEP_LINK_QUERIES.LANG_AND_REGION.LANGUAGE
    };
  }
  if (Object.keys(invalidMlangTags).length > 0) {
    errors.tags = {
      pane: 'settings',
      type: 'tags',
      target: 'tags',
      messageKey: 'components.header.validationErrorPopover.postSettingsErrors.tags',
      settingsModalQuery: POST_DEEP_LINK_QUERIES.GENERAL.TAGS
    };
  }
  if (invalidAuthorLanguage) {
    errors.author = {
      pane: 'settings',
      type: 'blogAuthorId',
      target: 'blogAuthorId',
      messageKey: 'components.header.validationErrorPopover.postSettingsErrors.author',
      settingsModalQuery: POST_DEEP_LINK_QUERIES.GENERAL.AUTHOR
    };
  }
  return errors;
};
export default postSettingsErrors;